export const SPEED_SELECTION: number[] = [0.8, 1, 1.2, 1.5, 2];

/**
 * Canonical form for a subtitle language code: lowercase, underscores.
 * Apply at write-time before storing into the persisted module so the state stays predictable
 * regardless of where the value comes from (JWT trLang in "ES", dropdown click in "es_ES",
 * URL param in "es-ES", etc).
 *
 * Returns the input untouched when empty/nullish.
 */
export const normalizeSubtitleLang = (value: string | null | undefined): string => {
    if (!value) return value || '';
    return value.toLowerCase().replace(/-/g, '_');
};

/**
 * Tolerant match between a Subtitle.lang ("en_US" style, as it lives on the weet model) and a
 * language code already stored in canonical form via {@link normalizeSubtitleLang}.
 *
 * The state side is canonical thanks to write-time normalization. The Subtitle.lang side comes
 * straight from the weet model and may be in any case (default is "en_US"), so we normalize it
 * here defensively, then:
 *  - exact match
 *  - ISO short-prefix fallback ("es" matches "es_ES"; "es_ES" matches "es_419")
 *
 * Returns false if either side is empty.
 */
export const matchSubtitleLang = (subLang: string, requested: string): boolean => {
    if (!subLang || !requested) return false;
    const a = normalizeSubtitleLang(subLang);
    const b = normalizeSubtitleLang(requested);
    if (a === b) return true;
    return a.split('_')[0] === b.split('_')[0];
};